<template>
  <block style="padding-bottom: 60px;">
    <template slot="header"
      >Finalizar atención</template
    >
    <div class="body">
      <div class="student-participation">
        <h4 class="section-title">¿EL ESTUDIANTE PARTICIPÓ?</h4>
        <div class="buttons has-addons">
          <button
            class="button"
            :class="participationButtonClass('yes', didParticipate)"
            @click.prevent="didParticipate = true"
          >
            sí
          </button>
          <button
            class="button"
            :class="participationButtonClass('no', didParticipate)"
            @click.prevent="didParticipate = false"
          >
            no
          </button>
        </div>
      </div>

      <div v-if="didParticipate === true">
        <div class="attention-details">
          <h4 class="section-title">RESULTADO</h4>
          <textarea v-model="result" placeholder="Especificar detalles..."></textarea>
        </div>
        <div class="has-private-comments-checkbox">
          <label>
            <input
              type="checkbox"
              v-model="hasPrivateComments"
              :disabled="!canWritePrivateComments"
            />
            Confidencial
          </label>
        </div>

        <div class="attention-emotion">
          <h4 class="section-title">SITUACIÓN DEL ESTUDIANTE</h4>

          <div class="emotion-picker">
            <button class="emotion" :class="emotionClass('YAY')" @click="selectedEmotion = 'YAY'">
              :)
            </button>
            <button class="emotion" :class="emotionClass('MEH')" @click="selectedEmotion = 'MEH'">
              :|
            </button>
            <button class="emotion" :class="emotionClass('SAD')" @click="selectedEmotion = 'SAD'">
              :(
            </button>
          </div>
        </div>
      </div>
      <div v-if="didParticipate === false">
        <div class="student-participation">
          <h4 class="section-title">¿EL ESTUDIANTE TODAVÍA SE ENCUENTRA EN LA INSTITUCIÓN?</h4>
          <div class="buttons has-addons">
            <button
              class="button"
              :class="participationButtonClass('no', didAbandon)"
              @click.prevent="didAbandon = false"
            >
              sí
            </button>
            <button
              class="button"
              :class="participationButtonClass('yes', didAbandon)"
              @click.prevent="didAbandon = true"
            >
              no, el estudiante ya desertó
            </button>
          </div>
        </div>

        <div class="attention-details">
          <h4 class="section-title">RESULTADO</h4>
          <textarea v-model="result" placeholder="Especificar detalles..."></textarea>
        </div>
      </div>

      <derivation-list
        :derivations.sync="derivations"
        v-if="didParticipate != null"
      ></derivation-list>
    </div>

    <div class="actions">
      <button
        class="button is-primary finish"
        :class="{ 'is-loading': loading }"
        :disabled="!isValid"
        @click="submit"
      >
        Agregar
      </button>
      &nbsp;
      <button
        class="button is-primary is-outlined cancel"
        :disabled="loading"
        @click="navigateTo('app.profile.attentions')"
      >
        Cancelar
      </button>
    </div>
  </block>
</template>

<script>
import gql from "graphql-tag"
import moment from "moment"
import STUDENT_ATTENTIONS from "../attentions/graphql/StudentAttentions.gql"
import Block from "@/components/_base/Block.vue"
import OverlayedMixin from "@/mixins/OverlayedMixin"
import DerivationList from "@/components/_base/DerivationList.vue"

export default {
  name: "ProfileAlert",
  mixins: [OverlayedMixin],
  props: {
    studentId: {
      type: String
    },
    attentionId: {
      type: String
    }
  },
  data() {
    return {
      didParticipate: null,
      didAbandon: null,
      result: "",
      selectedEmotion: "YAY",
      derivations: [],
      loading: false,
      hasPrivateComments: false,
      canWritePrivateComments: false
    }
  },
  created() {
    this.checkPermissions()
    console.log("Permission to write private comments:", this.canWritePrivateComments)
  },
  computed: {
    isValid() {
      // If the user still hasn't selected the participation
      if (this.didParticipate === null) {
        return false
      }

      // If the student did not particpate but the user has not selected
      // wheter they abandoned
      if (this.didParticipate === false && this.didAbandon === null) {
        return false
      }

      return true
    },
    validDerivations() {
      const derivations = this.derivations.map(d => {
        return {
          userId: d.chosenUser && d.chosenUser.id ? d.chosenUser.id : null,
          message: d.message || null
        }
      })
      // Filter the ones without a user
      const validDerivations = derivations.filter(d => d.userId != null)
      return validDerivations
    }
  },
  methods: {
    participationButtonClass(btn, prop) {
      const selectedClasses = {
        "is-primary": true,
        "is-selected": true
      }
      const nonSelectedClasses = {}

      if (btn == "yes" && prop === true) {
        return selectedClasses
      }
      if (btn == "no" && prop === false) {
        return selectedClasses
      }

      return nonSelectedClasses
    },

    emotionClass(emotion) {
      const selectedClasses = {
        "is-selected": true
      }
      const nonSelectedClasses = {}

      if (emotion == this.selectedEmotion) {
        return selectedClasses
      } else {
        return nonSelectedClasses
      }
    },

    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    },

    submit() {
      // FINISH ATTENTION

      // Save the user input in case of an error
      const didParticipate = this.didParticipate
      const didAbandon = this.didAbandon
      const result = this.result
      const hasPrivateComments = this.hasPrivateComments
      const evaluation = this.selectedEmotion

      // Call the graphql mutation
      this.loading = true
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation FinishAttention($input: FinishAttentionInput!) {
              finishAttention(input: $input) {
                id
                isDone
                performedAt
              }
            }
          `,
          // Parameters
          variables: {
            input: {
              attentionId: this.attentionId,
              studentId: this.studentId,
              didAssist: didParticipate,
              result,
              hasPrivateComments,
              evaluation,
              derivations: this.validDerivations
            }
          },
          refetchQueries: [
            {
              query: STUDENT_ATTENTIONS,
              variables: { studentId: this.studentId }
            }
          ],
          // Optimistic UI
          // Will be treated as a 'fake' result as soon as the request is made
          // so that the UI can react quickly and the user be happy
          optimisticResponse: {
            __typename: "Mutation",
            finishAttention: {
              __typename: "Attention",
              id: -1,
              isDone: true,
              performedAt: moment()
            }
          }
        })
        .then(data => {
          // Result
          this.loading = false

          // Route Depending on wheter the student abandoned
          if (!didParticipate && didAbandon) {
            this.navigateTo("app.profile.change_situation")
          } else {
            this.navigateTo("app.profile.attention_finished")
          }
        })
        .catch(error => {
          this.loading = false
          console.error(error)
        })
    },
    checkPermissions() {
      const injector = angular.element(document.body).injector()
      const permissionService = injector.get("permissionService")
      this.canWritePrivateComments = permissionService.escribirComentariosPrivados()
    }
  },
  components: {
    Block,
    DerivationList
  }
}
</script>

<style scoped>
.body {
  margin-bottom: 20px;
}

h4 {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.student-participation {
  margin-bottom: 35px;
}

.student-participation .button {
  padding: 0px 20px;
}

.body .section-title {
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  color: var(--color-neutral-90);
}

.attention-details {
  margin-bottom: 35px;
}

.attention-details textarea {
  box-sizing: border-box;
  resize: vertical !important;
  display: block;
  width: 100%;
  min-height: 66px;
  background-color: #f2f2f2;
  border-color: #e0e0e0;
  border-radius: 5px;
  padding: 10px 20px;
}

.attention-emotion {
  margin-bottom: 35px;
}

.emotion-picker {
  display: flex;
  width: 200px;
  justify-content: space-between;
}

.emotion-picker .emotion {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  transform: rotate(90deg);
  font-size: 22px;
  line-height: 22px;
  width: 50px;
  height: 50px;
}

.emotion-picker .emotion.is-selected {
  border-color: #18728e;
}

.actions .button.finish {
  padding: 0 45px;
}

.actions .button.cancel {
  padding: 0 20px;
}
</style>
